/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import "./normalize.css"
import "./layout.css"

const Layout = ({ containerId, children, article }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      mountainsImage: file(relativePath: { eq: "mountains.png" }) {
        childImageSharp {
          fixed(width: 997) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      mountainsBlackImage: file(relativePath: { eq: "mountains-black.png" }) {
        childImageSharp {
          fixed(width: 997) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  if (article) {
    return (
      <div id={containerId} className="article">
        <Header siteTitle={data.site.siteMetadata.title} />
        {children}
        <Footer />
      </div>
    )
  } else {
    return (
      <div id={containerId}>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div className="container" id={containerId}>
          {children}
          <Footer />
        </div>
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
